'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { UnrecoverableError } from '../components/views/UnrecoverableError';

export const metadata = {
  title: 'InsurGrid Link',
};

export default function GlobalError({ error }: { error: Error }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body>
        <UnrecoverableError />
      </body>
    </html>
  );
}
